import { addWorkshopUrl, createUploadUrl, deleteImageKeyUrl, getAllBaseServicesUrl, getAllWorkshopsUrl, getExtraServicesUrl, getRatingsUrl, getReservationAndServiceCountofAllWorkshopsUrl, getReviewsUrl, getThreeRandomWorkshopsUrl, getWorkshopByIdUrl, getWorkshopImageUrl, getWorkshopServicesUrl, getWorkshopsUrl, updateImageKeyUrl, updateWorkshopServicesUrl, updateWorkshopUrl } from "../../../shared/constants/apiUrls";
import { baseApi } from "./baseApi";

export const workshopApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getWorkshops: builder.query({
            query: ({ location, filter, car }) => ({
                url: `${getWorkshopsUrl}/${location.lat}/${location.lng}`,
                method: "POST",
                data: { filters: filter, car },
            }),

            transformResponse: (response, meta, arg) => {
                let workshops = response;

                return workshops.map((w, index) => ({
                    ...w,
                    orderNr: index + 1,
                }));
            },

            providesTags: [{ type: "Workshop", id: "ALL" }],
        }),
        getAllWorkshops: builder.query({
            query: () => ({
                url: `${getAllWorkshopsUrl}`,
                method: "GET"
            }),
            providesTags: [{ type: "Workshop", id: "ALL" }],
            extraOptions: { private: true },
        }),
        getThreeRandomWorkshops: builder.query({
            query: () => ({
                url: `${getThreeRandomWorkshopsUrl}`,
                method: "GET",
            }),
            providesTags: [{ type: "Workshop", id: "RANDOM" }],
        }),
        getReviews: builder.query({
            query: ({ workshopId, language }) => ({
                url: `${getReviewsUrl}`,
                method: "POST",
                data: { workshopId, language },
            }),
            providesTags: [{ type: "Workshop", id: "REVIEWS" }],
            keepUnusedDataFor: 300,
        }),
        getRatings: builder.query({
            query: ({workshopId}) => ({
                url: `${getRatingsUrl}`,
                method: "POST",
                data: { workshopId },
            }),
            providesTags: [{ type: "Workshop", id: "RATINGS" }],
            keepUnusedDataFor: 300,
        }),
        getWorkshopDetails: builder.query({
            query: (url) => ({
                url: `${url}`,
                method: "GET"
            }),
            providesTags: [{ type: "Workshop", id: "DETAIL" }],
        }),
        getWorkshopServices: builder.query({
            query: (workshopId) => ({
                url: `${getWorkshopServicesUrl}/${workshopId}`,
                method: "GET"
            }),
            providesTags: [{ type: "Workshop", id: "SERVICES" }],
        }),
        getExtraServices: builder.query({
            query: () => ({
                url: `${getExtraServicesUrl}`,
                method: "GET"
            }),
            providesTags: [{ type: "Workshop", id: "SERVICES" }],
        }),
        getWorkshopById: builder.query({
            query: (id) => ({
                url: `${getWorkshopByIdUrl}/${id}`,
                method: "GET"
            }),
            providesTags: [{ type: "Workshop", id: "DETAIL" }],
        }),
        getAllBaseServices: builder.query({
            query: () => ({
                url: `${getAllBaseServicesUrl}`,
                method: "GET"
            }),
            providesTags: [{ type: "Workshop", id: "SERVICES" }],
        }),
        updateWorkshop: builder.mutation({
            query: ({ workshopId, payload }) => ({
                url: `${updateWorkshopUrl}/${workshopId}`,
                method: "PATCH",
                data: payload                
            }),
            extraOptions: { private: true },
            invalidatesTags: [{ type: "Workshop", id: "DETAIL" }, { type: "Workshop", id: "ALL" }],
        }),
        updateWorkshopServices: builder.mutation({
            query: ({ workshopId, payload }) => ({
                url: `${updateWorkshopServicesUrl}/${workshopId}`,
                method: "PATCH",
                data: payload,
            }),
            extraOptions: { private: true },
            invalidatesTags: [{ type: "Workshop", id: "SERVICES" }],
        }),
        getReservationAndServiceCountofAllWorkshops: builder.query({
            query: () => ({
                url: `${getReservationAndServiceCountofAllWorkshopsUrl}`,
                method: "GET",
            }),
            extraOptions: { private: true },
            providesTags: [{ type: "Workshop", id: "RESERVATION_SERVICE_COUNT" }],
        }),
        addWorkshop: builder.mutation({
            query: (workshopData) => ({
                url: `${addWorkshopUrl}`,
                method: "POST",
                data: workshopData,
            }),
            extraOptions: { private: true },
            invalidatesTags: [{ type: "Workshop", id: "ALL" }],
        }),
        createUploadURL: builder.mutation({
            query: ({ workshopId, contentType, variant }) => ({
                url: `${createUploadUrl}`,
                method: "POST",
                data: { workshopId, contentType, variant },
            }),
            extraOptions: { private: true },
            invalidatesTags: [{ type: "Workshop", id: "DETAIL" }],
        }),
        uploadFile: builder.mutation({
            query: ({ uploadUrl, file }) => ({
                url: `${uploadUrl}`,
                method: "PUT",
                headers: { "Content-Type": file.type },
                data: file,
            }),
            invalidatesTags: [{ type: "Workshop", id: "DETAIL" }],
        }),
        updateImageKey: builder.mutation({
            query: ({ workshopId, variant, newKey }) => ({
                url: `${updateImageKeyUrl}`,
                method: "PUT",
                data: { workshopId, variant, newKey },
            }),
            extraOptions: { private: true },
            invalidatesTags: [{ type: "Workshop", id: "DETAIL" }],
        }),
        deleteImageKey: builder.mutation({
            query: ({ workshopId, variant }) => ({
                url: `${deleteImageKeyUrl}`,
                method: "PUT",
                data: { workshopId, variant },
            }),
            extraOptions: { private: true },
            invalidatesTags: [{ type: "Workshop", id: "DETAIL" }],
        }),
        getWorkshopImageUrl: builder.query({
            query: ({workshopId, variant}) => ({
                url: `${getWorkshopImageUrl}/${workshopId}/${variant}`,
                method: "GET",
            }),
            providesTags: [{ type: "Workshop", id: "DETAIL" }],
        }),
    }),
});
export const {
    useGetWorkshopsQuery,
    useGetThreeRandomWorkshopsQuery,
    useLazyGetReviewsQuery,
    useGetRatingsQuery,
    useGetWorkshopDetailsQuery,
    useGetWorkshopServicesQuery,
    useGetExtraServicesQuery,
    useGetWorkshopByIdQuery,
    useGetAllBaseServicesQuery,
    useUpdateWorkshopMutation,
    useUpdateWorkshopServicesMutation,
    useGetAllWorkshopsQuery,
    useGetReservationAndServiceCountofAllWorkshopsQuery,
    useAddWorkshopMutation,
    useCreateUploadURLMutation,
    useUploadFileMutation,
    useUpdateImageKeyMutation,
    useGetWorkshopImageUrlQuery,
    useDeleteImageKeyMutation
} = workshopApi;
